import React, { Component, ReactNode } from 'react';
import { isChunkLoadError } from '../../utils/lazyWithRetry';

/** Keep navigation available if a route's JavaScript cannot be downloaded. */
export default class TenantModuleBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: Error) { return { error }; }

  render() {
    if (this.state.error) {
      return <section className="srs-module" role="alert">
        <h1>{isChunkLoadError(this.state.error) ? 'This page could not be downloaded' : 'This page could not be opened'}</h1>
        <p>Please reload the page to try again.</p>
        <button className="btn btn-primary" onClick={() => window.location.reload()}>Reload page</button>
      </section>;
    }
    return this.props.children;
  }
}
